import executeServerApi from 'assets/utils/server/ServerApi';
import { getDefaultHeaders, HttpMethod } from 'config/Api.Config';

type Request = Api.Core.VehicleClass.List.IRequest;
type Response = Api.Core.VehicleClass.List.IResponse;
type Headers = Api.Core.VehicleClass.List.IHeaders;
const url = '/api/ProductManagement/VehicleClass';
export default async function vehicleClassListApi(body?: Request): Promise<Api.Res<Response>> {
  return await executeServerApi<Request, Response, Headers>({
    method: HttpMethod.get,
    url,
    body,
    headers: getDefaultHeaders(),
  });
}
